<div class="table-container">

  <img alt="monitoring-info" class="monitoring-info" src="/img/monitoring-info.png">

  <div class="header-row">
    <div class="header">
      <span class="text-content">
        {{ 'Monitoring.USA.Title' | translate }}
      </span>
      <object
        class="icon"
        data="/img/usa-monitoring.svg"
        type="image/svg+xml"
      ></object>
    </div>
    <div class="header empty"></div>
    <div class="header">
      <span class="text-content">
        {{ 'Monitoring.Ireland.Title' | translate }}
      </span>
      <object
        class="icon"
        data="/img/ireland-monitoring.svg"
        type="image/svg+xml"
      ></object>
    </div>
  </div>

  <div *ngFor="let item of items" class="data-row desktop">

    <div class="cell">
      <div
        [innerHTML]="(isMobile ? 'MonitoringMobile.USA.' : 'Monitoring.USA.') + item | translate | translateCut:0"></div>
      <div [innerHTML]="(isMobile ? 'MonitoringMobile.USA.' : 'Monitoring.USA.') + item | translate | translateCut:1"
           class="small"></div>
    </div>
    <div class="cell titles-cell">
      <object
        data="/img/arrow-left.svg"
        type="image/svg+xml"
      ></object>
      <div>
        {{ 'Monitoring.Titles.' + item | translate | translateCut:0 }}
        <div class="small">{{ 'Monitoring.Titles.' + item | translate | translateCut:1 }}</div>
      </div>
      <object
        data="/img/arrow-right.svg"
        type="image/svg+xml"
      ></object>
    </div>
    <div class="cell">
      <div
        [innerHTML]="(isMobile ? 'MonitoringMobile.Ireland.' : 'Monitoring.Ireland.') + item | translate | translateCut:0"></div>
      <div
        [innerHTML]="(isMobile ? 'MonitoringMobile.Ireland.' : 'Monitoring.Ireland.') + item | translate | translateCut:1"
        class="small"></div>
    </div>

  </div>

  <div class="data-container">
    <div class="title-container">

      <object
        class="icon"
        data="/img/usa-monitoring-mobile.svg"
        type="image/svg+xml"
      ></object>

      <span class="text-content">
        {{ 'Monitoring.USA.MobileTitle' | translate }}
      </span>
    </div>

    <hr>

    <div *ngFor="let item of itemsMobile" class="data-row">

      <div>
        {{ 'Monitoring.Titles.' + item | translate | translateCut:0 }}
        <div class="small">{{ 'Monitoring.Titles.' + item | translate | translateCut:1 }}</div>
      </div>

      <div class="cell">
        <div
          [innerHTML]="(isMobile ? 'MonitoringMobile.USA.' : 'Monitoring.USA.') + item | translate | translateCut:0"></div>
        <div
          [innerHTML]="(isMobile ? 'MonitoringMobile.USA.' : 'Monitoring.USA.') + item | translate | translateCut:1"
          class="small"></div>
      </div>

      <hr>

    </div>

  </div>

  <div class="data-container">
    <div class="title-container">

      <object
        class="icon"
        data="/img/ireland-monitoring-mobile.svg"
        type="image/svg+xml"
      ></object>

      <span class="text-content">
        {{ 'Monitoring.Ireland.MobileTitle' | translate }}
      </span>
    </div>

    <hr>

    <div *ngFor="let item of itemsMobile" class="data-row">

      <div>
        {{ 'Monitoring.Titles.' + item | translate | translateCut:0 }}
        <div class="small">{{ 'Monitoring.Titles.' + item | translate | translateCut:1 }}</div>
      </div>

      <div class="cell">
        <div
          [innerHTML]="(isMobile ? 'MonitoringMobile.Ireland.' : 'Monitoring.Ireland.') + item | translate | translateCut:0"></div>
        <div
          [innerHTML]="(isMobile ? 'MonitoringMobile.Ireland.' : 'Monitoring.Ireland.') + item | translate | translateCut:1"
          class="small"></div>
      </div>

      <hr>

    </div>

  </div>

</div>
